
import * as React from 'react';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import RectangleIcon from '@mui/icons-material/Rectangle';
import { GeoContext } from '../GeoContext'
import * as C from "../map_utils/constants";
import * as LU from "../map_utils/legendUtils";

function createData(id, key, value) {
  return { id, key, value };
}

export default function MapLegend() {
  const geoContext = React.useContext(GeoContext);

  let conseqTypeXref = C.consequenceTypeXref[geoContext.getConsequenceType]
  // let consequenceKey = conseqTypeXref.name;
  let location = C.locationConfigs[geoContext.getLocation];
  let roadLegendVisibility = {};

  const structRows = [];
  const roadRows = [];
  let structBreakpoints;
  let roadBreakpoints;
  let structColors;
  let roadColors;

  if (geoContext.getConsequenceType == "damages") {
    structBreakpoints = LU.damagesPrevBps;
    structColors = LU.damagesPrevColors;
    roadLegendVisibility = { 'display': 'none' };
  } else if (["dwp", "dwop"].includes(geoContext.getConsequenceType)) {
    structBreakpoints = LU.damagesBps;
    structColors = LU.damagesColors;
    roadLegendVisibility = { 'display': 'none' };
  } else { // Else any flooding
    structBreakpoints = LU.structFloodingBps;
    structColors = LU.structFloodingColors;
    roadBreakpoints = LU.roadFloodingBps;
    roadColors = LU.roadFloodingColors;
  }

  for (let i in structBreakpoints) {
    let bp = structBreakpoints[i];
    if (bp === '=== 0') {
      bp = '= 0'
    }
    const color = LU.getHexFromColor(structColors[i]);
    let key = <RectangleIcon style={{ fill: LU.getHexFromColor(structColors[i]) }} />;
    structRows.push(createData(i, key, bp));
  }

  if (roadBreakpoints) {
    for (let i in roadBreakpoints) {
      let bp = roadBreakpoints[i];
      if (bp === '=== 0') {
        bp = '= 0'
      }
      let key = <RectangleIcon style={{ fill: LU.getHexFromColor(roadColors[i]) }} />;
      roadRows.push(createData(i, key, bp));
    }
  }

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    // hide border
    '&:td': {
      border: 0,
    },
  }));

  return (
    <TableContainer component={Paper} style={{
      maxWidth: 236, position: "absolute", top: 70, left: 10,
    }}>
      <Table aria-label="3D Map Coloring Legend">
        <TableHead>
          <TableRow>
            <TableCell colSpan={2}>{conseqTypeXref.title}</TableCell>
            <TableCell>Structure<br />Count</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {structRows.map((row) => (
            <StyledTableRow key={`${row.id}`}>
              <TableCell padding="none" style={{ paddingLeft: 10, paddingTop: 5 }} scope="row">{row.key}</TableCell>
              <TableCell padding="none">{row.value}</TableCell>
              <TableCell padding="none" style={{ paddingLeft: 15 }}>{geoContext.getStructureCounts[row.id]}</TableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
